import { Component, OnInit } from '@angular/core';
import { MaterialesService } from '../materiales.service';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-az-media',
  templateUrl: './az-media.component.html',
  styleUrls: ['./az-media.component.css','../../assets/scss/styles.scss',
	'../../assets/scss/general-board.scss', 
    '../../assets/scss/fonts.scss',    
    '../../assets/ema/main.scss']
})
export class AzMediaComponent implements OnInit {
  public materiales;
  public contenido = this.contenidoService.getContenido("az-media");
  constructor(private materialesService: MaterialesService, private contenidoService: ContenidoService) { }

  ngOnInit() { 
    this.materialesService.getMaterialesByMarc('Azamara')
      .then(materiales => {
        this.materiales = materiales;
      })
      .catch(err => console.error(err));
  }

}
